// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3ZEGC","title":"Header_title__3aoJy","left":"Header_left__2-K2-","clinicName":"Header_clinicName__2BM-i"};